var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_group_light",
    "data-name": "UI icon/group/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M0,10.143A5.143,5.143,0,0,0,4.55,5.072,5.143,5.143,0,0,0,0,0,7.563,7.563,0,0,1,1.95,5.072,7.563,7.563,0,0,1,0,10.143Z",
    transform: "translate(16.25 0.039)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract-2",
    "data-name": "Subtract",
    d: "M3.508,8.933a1.3,1.3,0,0,0,2.6,0V6.377A6.437,6.437,0,0,0,0,0,10.22,10.22,0,0,1,2.995,4.476a3.766,3.766,0,0,1,.513,1.9Z",
    transform: "translate(19.892 12.789)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_631_Stroke_",
    "data-name": "Vector 631 (Stroke)",
    d: "M6.5,2.556A3.867,3.867,0,0,0,2.6,6.389V8.944a1.289,1.289,0,0,1-1.3,1.278A1.289,1.289,0,0,1,0,8.944V6.389A6.445,6.445,0,0,1,6.5,0h7.8a6.445,6.445,0,0,1,6.5,6.389V8.944a1.3,1.3,0,0,1-2.6,0V6.389a3.867,3.867,0,0,0-3.9-3.833Z",
    transform: "translate(0 12.778)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_132_Stroke_",
    "data-name": "Ellipse 132 (Stroke)",
    d: "M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10ZM5,2.5A2.5,2.5,0,1,0,7.5,5,2.5,2.5,0,0,0,5,2.5Z",
    transform: "translate(5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.59b6a13ccb886aef3874cda4718a62fd.svg";
export { ForwardRef as ReactComponent };